import { createSlice } from '@reduxjs/toolkit';
import { API_STATUS } from '../../constants';
import { positionSubscriptionStoreKey } from './positionSubscription.const';
import {
  confirmCandidatePositionSubscription,
  createCandidatePositionSubscription,
  createReferralPositionSubscription,
  getSubscriptionDetails,
  resubscribeReferralPositionSubscription,
  unsubscribePositionSubscription,
  updatePositionSubscription,
} from './positionSubscription.thunks';
import { IPositionSubscriptionSliceState } from './positionSubscription.types';

const initialState: IPositionSubscriptionSliceState = {
  subscriptionDetails: {
    apiStatus: API_STATUS.IDLE,
    data: null,
  },
  createSubscriptionAPIStatus: API_STATUS.IDLE,
  confirmSubscriptionAPIStatus: API_STATUS.IDLE,
  updateSubscriptionAPIStatus: API_STATUS.IDLE,
  unsubscribeSubscriptionAPIStatus: API_STATUS.IDLE,
  resubscribeSubscriptionAPIStatus: API_STATUS.IDLE,
};

export const positionSubscriptionSlice = createSlice({
  name: positionSubscriptionStoreKey,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get Subscription Details
      .addCase(getSubscriptionDetails.pending, (state) => {
        state.subscriptionDetails.apiStatus = API_STATUS.LOADING;
        state.subscriptionDetails.data = null;
      })
      .addCase(getSubscriptionDetails.fulfilled, (state, action) => {
        state.subscriptionDetails.apiStatus = API_STATUS.COMPLETE;
        state.subscriptionDetails.data = action.payload;
      })
      .addCase(getSubscriptionDetails.rejected, (state) => {
        state.subscriptionDetails.apiStatus = API_STATUS.FAILED;
      })
      // Create Subscription
      .addCase(createCandidatePositionSubscription.pending, (state) => {
        state.createSubscriptionAPIStatus = API_STATUS.LOADING;
      })
      .addCase(
        createCandidatePositionSubscription.fulfilled,
        (state, action) => {
          state.createSubscriptionAPIStatus = API_STATUS.COMPLETE;
          state.subscriptionDetails.data = action.payload;
        },
      )
      .addCase(createCandidatePositionSubscription.rejected, (state) => {
        state.createSubscriptionAPIStatus = API_STATUS.FAILED;
      })
      .addCase(createReferralPositionSubscription.pending, (state) => {
        state.createSubscriptionAPIStatus = API_STATUS.LOADING;
      })
      .addCase(
        createReferralPositionSubscription.fulfilled,
        (state, action) => {
          state.createSubscriptionAPIStatus = API_STATUS.COMPLETE;
          state.subscriptionDetails.data = action.payload;
        },
      )
      .addCase(createReferralPositionSubscription.rejected, (state) => {
        state.createSubscriptionAPIStatus = API_STATUS.FAILED;
      })
      // Confirm Subscription
      .addCase(confirmCandidatePositionSubscription.pending, (state) => {
        state.confirmSubscriptionAPIStatus = API_STATUS.LOADING;
      })
      .addCase(
        confirmCandidatePositionSubscription.fulfilled,
        (state, action) => {
          state.confirmSubscriptionAPIStatus = API_STATUS.COMPLETE;
          state.subscriptionDetails.data = action.payload;
        },
      )
      .addCase(confirmCandidatePositionSubscription.rejected, (state) => {
        state.confirmSubscriptionAPIStatus = API_STATUS.FAILED;
      })
      // Update Subscription
      .addCase(updatePositionSubscription.pending, (state) => {
        state.updateSubscriptionAPIStatus = API_STATUS.LOADING;
      })
      .addCase(updatePositionSubscription.fulfilled, (state, action) => {
        state.updateSubscriptionAPIStatus = API_STATUS.COMPLETE;
        state.subscriptionDetails.data = action.payload;
      })
      .addCase(updatePositionSubscription.rejected, (state) => {
        state.updateSubscriptionAPIStatus = API_STATUS.FAILED;
      })
      // Resubscribe Referral
      .addCase(resubscribeReferralPositionSubscription.pending, (state) => {
        state.resubscribeSubscriptionAPIStatus = API_STATUS.LOADING;
      })
      .addCase(
        resubscribeReferralPositionSubscription.fulfilled,
        (state, action) => {
          state.resubscribeSubscriptionAPIStatus = API_STATUS.COMPLETE;
          state.subscriptionDetails.data = action.payload;
        },
      )
      .addCase(resubscribeReferralPositionSubscription.rejected, (state) => {
        state.resubscribeSubscriptionAPIStatus = API_STATUS.FAILED;
      })
      // Unsubscribe Subscription
      .addCase(unsubscribePositionSubscription.pending, (state) => {
        state.unsubscribeSubscriptionAPIStatus = API_STATUS.LOADING;
      })
      .addCase(unsubscribePositionSubscription.fulfilled, (state, action) => {
        state.unsubscribeSubscriptionAPIStatus = API_STATUS.COMPLETE;
        state.subscriptionDetails.data = action.payload;
      })
      .addCase(unsubscribePositionSubscription.rejected, (state) => {
        state.unsubscribeSubscriptionAPIStatus = API_STATUS.FAILED;
      });
  },
});
